import { useMemo } from 'react'

import type { Session } from 'next-auth'
import { useSession } from 'next-auth/react'
const ADMIN_ROLES = ['admin', 'sebrae_admin']

export const useCurrentUser = () => {
  const { data: session } = useSession()

  const currentUser = session?.user as Session['user'] | undefined

  const isAdmin = useMemo(() => {
    if (!currentUser?.roles) return false
    return currentUser.roles.some(role => ADMIN_ROLES.includes(role.slug))
  }, [currentUser?.roles])

  return {
    currentUser,
    isAdmin
  }
}
